<svg class="w-[30px] h-[30px] user-select-none cursor-pointer" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
  <circle cx="20" cy="20" r="20" fill="#F7F7F7" />
  <path
    d="M20.0026 20c2.3012 0 4.1667-1.8655 4.1667-4.1667
    0-2.3012-1.8655-4.1667-4.1667-4.1667-2.3012 0-4.1667 1.8655-4.1667 4.1667 0
    2.3012 1.8655 4.1667 4.1667 4.1667Z"
    stroke="#8F92A1" />
  <path
    d="M23.3347 23.3333h5m-4.1667 5h-9.7783c-.2364
    0-.47-.0502-.6855-.1474-.2154-.0971-.4078-.239-.5642-.4162-.1564-.1771-.2734-.3855-.3431-.6114-.0698-.2258-.0907-.4639-.0614-.6984l.325-2.6033c.0756-.6048.3695-1.1612.8265-1.5645.4571-.4033
    1.0457-.6257 1.6552-.6255h.2925l8.3333 6.6667Zm1.6667-7.5v5-5Z"
    stroke="#8F92A1"
    stroke-linecap="round"
    stroke-linejoin="round" />
</svg>
